import React from 'react';
import PropTypes from 'prop-types';
import {OverlayTrigger, Popover, ProgressBar} from 'react-bootstrap';
import styled, {css} from 'styled-components';

class ProgressBarItem extends React.Component {

  render() {
    const popoverScore = (
      <Popover id={0}>
        <div> {this.props.score + '%'}  </div>
      </Popover>
    );

    return (
      <OverlayTrigger trigger={['hover', 'focus']} placement={this.props.placement} overlay={popoverScore}>
        <Progress style={{maxWidth: this.props.width}} score={this.props.score} bsStyle={null} now={this.props.score} />
      </OverlayTrigger>
    );
  }
}

const getColor = (score) => {
  const min = [0, 100, 93];
  const max = [120, 96, 59];

  const diffH = ((max[0] - min[0])*(score/100)) + min[0];
  let diffV = (Math.abs(max[2] - min[2])*(score/100)) + max[2];

  if (score <= 60 && score >= 40) {
    diffV = 90;
  }

  return `hsl(${diffH}, 100%, ${diffV / 2}%) !important`;
};

const Progress = styled(ProgressBar)`
  > .progress-bar {
    ${props => css`
      background-color: ${getColor(props.score)};
    `}
  }
`;

ProgressBarItem.propTypes = {
  placement: PropTypes.string,
  score: PropTypes.number,
  width: PropTypes.string
};

export default ProgressBarItem;


// WEBPACK FOOTER //
// ./src/components/teams/ProgressBar.js